module.exports = __webpack_public_path__ + "img/system1.90253de3.png";